import { useRouteError } from 'react-router';

const ErrorPage = () => {
  const routeError = useRouteError() as Error;
  console.error('Route error:', routeError);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="font-semibold">
        Error while processing your request. Please try again later.
      </p>
    </div>
  );
};

export default ErrorPage;
